import { DirectionProvider, MantineProvider } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { directionOf } from '@web/i18n';
import { queryClient } from './queryClient';
import { router } from './router';
import { theme } from './theme';

export function App() {
  const { i18n } = useTranslation();
  const dir = directionOf(i18n.resolvedLanguage ?? 'en');
  return (
    <DirectionProvider initialDirection={dir} detectDirection key={dir}>
      <MantineProvider theme={theme} defaultColorScheme="light">
        <QueryClientProvider client={queryClient}>
          <ModalsProvider>
            <Notifications position="top-right" autoClose={4000} />
            <RouterProvider router={router} />
          </ModalsProvider>
        </QueryClientProvider>
      </MantineProvider>
    </DirectionProvider>
  );
}
